import { render } from "./ModalSoporte.vue?vue&type=template&id=3dd4a68a&ts=true"
import script from "./ModalSoporte.vue?vue&type=script&lang=ts"
export * from "./ModalSoporte.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\18\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__